import { FormValidator } from "@CubeComponents/Mui_Form/FormValidator";
import { presetSectionsCodeObject } from "@Helpers";
import { optionsViewType } from "@Features/portal-settings";
import { formStatuses } from "./constants";
import { FormControlLabel, RadioGroup } from "@mui/material";
import RadioButton from "@CubeComponents/Mui_Form/RadioButton";
import { getUserSelectionModeOptions } from "../FormFlow/formFlow.constants";

export const statusTemplate = (stage: any) => {
  let status = "";
  let color;
  if (stage == formStatuses.inProgress) {
    status = "In progress";
    color = "bg-system_colour_12";
  }
  if (stage == formStatuses.submitted) {
    status = "Submitted";
    color = "bg-system_colour_45";
  }
  if (stage == formStatuses.approved) {
    status = "Approved";
    color = "bg-positive_communication";
  }
  if (stage == formStatuses.rejected) {
    status = "Rejected";
    color = "bg-system_colour_8";
  }
  return (
    <div className={`h-8 ${color} w-fit ps-3 gap-2 bg-opacity-30 rounded-2xl pe-3 flex items-center`}>
      <span className={`${color} rounded-full h-3 w-3`} />
      <span className="font-semibold">{status}</span>
    </div>
  );
};
export const addValidationToInputFields = ({
  formData,
  template = [],
  formObject,
  rows = [],
  modifySection = [],
}: any) => {
  const allSectionsInCurrentLevel: any[] = [];
  const excludedTypes = ["users", "fileUpload", "image", "url"];
  if (formData && formData._id) {
    formData.formFlow[formData.currentLevelOfForm].dataSource.map((data: any) => {
      if (data.type === "Fill") {
        data.sections.map((section: any) => allSectionsInCurrentLevel.push(section._id));
      } else if (data.type === "Modify") {
        data.sections.map((section: any) => {
          if (modifySection.includes(section._id)) {
            allSectionsInCurrentLevel.push(section._id);
          }
        });
      }
    });
    template = formData.selectedForm.template;
  } else if (template && template.length) {
    template?.forEach((section: any) => allSectionsInCurrentLevel.push(section._id));
  } else if (formData && formData.selectedForm) {
    template = formData.selectedForm.template || [];
    template?.forEach((section: any) => allSectionsInCurrentLevel.push(section._id));
  }

  const options = { rules: {} };
  template?.some((section: any) => {
    if (
      section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_TABLE_SECTION &&
      allSectionsInCurrentLevel.includes(section._id)
    ) {
      section.questionFields.some((eachField: any) => {
        section.tableDataSource.some((row: any) => {
          const isSelectWithListView =
            (eachField.fieldType === "multi-select" || eachField.fieldType === "single-select") &&
            eachField.viewType === optionsViewType.LIST;
          if (!excludedTypes.includes(eachField.fieldType) && !isSelectWithListView) {
            const ruleObj: any = {};
            const ruleName = `${row.rowId}${eachField._id}`;
            if (eachField.isMandatory === true) {
              ruleObj.required = [true, "* Required"];
            }
            if (["single-line", "multi-line"].includes(eachField.fieldType)) {
              ruleObj.minLength = eachField.minFieldLimit ?? 0;
              if (eachField.maxFieldLimit) {
                ruleObj.maxLength = eachField.maxFieldLimit;
              }
            } else if (["date-time"].includes(eachField.fieldType)) {
              ruleObj.regex = [
                "^([0-2][0-9]|3[0-1])/((0[1-9])|(1[0-2]))/([1-9][0-9]{3}) ((0[1-9])|(1[0-2])):([0-5][0-9]):(AM|PM)$",
                "Please enter a valid date",
              ];
            }
            options.rules[ruleName] = {
              ...ruleObj,
            };
            if (rows && Array.isArray(rows)) {
              rows.forEach((row: any) => {
                if (!row.isFolder) {
                  options.rules[`${row.id}_${ruleName}`] = {
                    ...ruleObj,
                  };
                }
              });
            } else {
              options.rules[ruleName] = {
                ...ruleObj,
              };
            }
          }
        });
      });
    } else if (section.questionFields) {
      if (allSectionsInCurrentLevel.includes(section._id)) {
        section.questionFields.some((eachField: any) => {
          const isSelectWithListView =
            (eachField.fieldType === "multi-select" || eachField.fieldType === "single-select") &&
            eachField.viewType === optionsViewType.LIST;
          if (!excludedTypes.includes(eachField.fieldType) && !isSelectWithListView) {
            const ruleName = `${eachField._id}`;
            const ruleObj: any = {};
            if (eachField.isMandatory === true) {
              ruleObj.required = [true, "* Required"];
            }
            if (["single-line", "multi-line"].includes(eachField.fieldType)) {
              ruleObj.minLength = eachField.minFieldLimit ?? 0;
              if (eachField.maxFieldLimit) {
                ruleObj.maxLength = eachField.maxFieldLimit;
              }
            } else if (["date-time"].includes(eachField.fieldType)) {
              ruleObj.regex = [
                "^([0-2][0-9]|3[0-1])/((0[1-9])|(1[0-2]))/([1-9][0-9]{3}) ((0[1-9])|(1[0-2])):([0-5][0-9]):(AM|PM)$",
                "Please enter a valid date",
              ];
            }
            if (rows && Array.isArray(rows)) {
              rows.forEach((row: any) => {
                if (!row.isFolder) {
                  options.rules[`${row.id}_${ruleName}`] = {
                    ...ruleObj,
                  };
                }
              });
            } else {
              options.rules[ruleName] = {
                ...ruleObj,
              };
            }
          }
        });
      }
    }
    formObject.current = new FormValidator("#formData", options);
  });
};
/**
 * "Who should be assigned?" radios. The options themselves live in
 * `FormFlow/formFlow.constants` so web and mobile offer exactly the same choices.
 */
export const getUserSelection = (heading: any, userSelectionMode: any, handleUserSelectionModeChange: any) => (
  <div className="flex flex-col gap-2">
    <span>{heading}</span>
    <span>
      <RadioGroup value={userSelectionMode} onChange={handleUserSelectionModeChange}>
        {getUserSelectionModeOptions().map((option) => (
          <FormControlLabel key={option.value} value={option.value} control={<RadioButton />} label={option.label} />
        ))}
      </RadioGroup>
    </span>
  </div>
);
